import React from "react";
import { Box , styled } from "@mui/material";
import {Controlled as ControlledEditor} from 'react-codemirror2';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/css/css';
import 'codemirror/mode/javascript/javascript';
import './Editor.css';

const Container = styled(Box)`
    flex-grow : 1;
    flex-basic : 0;
    display : flex;
    flex-direction : column;
    padding: 0 3px 3px;
`

const Heading = styled(Box)`
    display : flex;
    padding : 9px 12px;
    background : #080202;
    color : white;
    font-weight : bold;
    font-family: 'Fasthand', cursive;
`

const Editor = ({heading , color , value , onChange}) => {

    const handleChange = (editor , data , value) => {
        onChange(value);
    }

    return (
        <Container>
            <Box>
                <Heading>
                    <Box component="span" style={{backgroundColor:color , height:20 , width:20 , display:'flex' , placeContent:'center' , borderRadius : 10 , marginRight : 5 , paddingBottom : 2}}></Box>
                    {heading}
                </Heading>
            </Box>
            <ControlledEditor options={{lineNumbers : true}} className='controlled-editor' value={value} onBeforeChange={handleChange}/>
        </Container>
    )
}

export default Editor;